import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
import useSWRInfinite from "swr/infinite";

function useGetDataFromSelect(path, params, isInfinityLoading = false) {
  const response = useSWR(
    !!path && !isInfinityLoading
      ? {
          path,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );

  // Trường hợp infinite loading: dùng useSWRInfinite và flatten dữ liệu
  const limit = Number(params?.limit) || 10;

  const swrInfinite = useSWRInfinite(
    isInfinityLoading && !!path
      ? (index, previousPageData) => {
          // Nếu page trước không có data hoặc ít hơn limit → đã hết dữ liệu
          if (previousPageData && Array.isArray(previousPageData.data) && previousPageData.data.length < limit) {
            return null;
          }

          return {
            path,
            method: "GET",
            params: {
              ...params,
              skip: index * limit,
              limit,
            },
          };
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );

  if (!isInfinityLoading) {
    return response;
  }

  const { data: pages, error, isLoading, isValidating, size, setSize, mutate } = swrInfinite;

  const flatData = Array.isArray(pages) ? pages.flatMap((page) => (Array.isArray(page?.data) ? page.data : [])) : [];

  const totalCount = Array.isArray(pages) && pages[0]?.count != null ? pages[0].count : undefined;
  const hasMore = typeof totalCount === "number" ? flatData.length < totalCount : true;

  return {
    data: {
      data: flatData,
      count: totalCount,
    },
    error,
    isLoading,
    isValidating,
    size,
    setSize,
    hasMore,
    mutate,
  };
}

export default useGetDataFromSelect;
